<template>
    <div class="canvas">
            <div class="canvas-out mt-60">
              <div class="canvas-out-conter">
                <div v-for="info,a in list" :key="a">
                  <div class="conter-row" @click="handleDetail(info.doc_id)">
                    <img :src="getImgSrc(info)" alt="" />
                    <div>{{info.train_title}}</div>
                    <div>{{info.position}}</div>
                  </div>
                </div>
              </div> 
            </div>
      </div>
</template>
<script>
export default {
  props:{
    list:{
      type:Array,
      default: () => ({})
    }
  },
  data () {
    return {
      type:'add',
      param:{
                pageIndex:1,
                pageSize:10,
            },
    }
  },
  created(){
    this.position_type = '1'
  },
  methods: {
    changeType(flg){
      this.$emit('handleMember',flg);
    },
    // 获取图片地址
    getImgSrc(info){
        let srcSource = null
        let imgInfo
        if (typeof info.train_content === "string") {
            srcSource = info.train_content.match(/src="([^"]*)"/g);
        }
        if (srcSource) {
            let imgList = srcSource[0].split('src=')
            imgInfo = imgList[1].replace("\"","").replace("\"","")
        }
        return imgInfo
    },
    handleDetail(val){
        this.$emit('handleDetail', val)
    },
  }
}
</script>
<style lang="scss" scoped>
@import './PublicationShow.scss';
</style>
